import { PaymentStatus } from './payment';

const APPLE_PAY_VERSION_NUMBER = 3;
const merchantIdentifier = process.env.REACT_APP_APPLE_PAY_MERCHANT_ID;

const CURRENCY_CODE = 'KZT';

// Apple закрывает платёжный шит, если completePayment не вызван в течение 30 с после авторизации
const APPLE_PAY_AUTHORIZATION_TIMEOUT_MS = 25000;

// Статусы процессинга, при которых платёж принят и шиту отдаём STATUS_SUCCESS
const APPLE_PAY_SUCCESS_STATUSES: number[] = [
  PaymentStatus.WAIT_PROCESSING,
  PaymentStatus.WAIT_PAYMENT_CONFIRM,
  PaymentStatus.HOLDED,
  PaymentStatus.PAYMENT_SUCCESS,
];

const ApplePayButtonStatus = { UNKNOWN: 0, AVAILABLE: 1, NOT_AVAILABLE: 2 };
const PaymentStatusApplePay = { SUCCESS: 0, FAILURE: 1, CANCEL: 2 };

export {
  merchantIdentifier,
  APPLE_PAY_VERSION_NUMBER,
  APPLE_PAY_AUTHORIZATION_TIMEOUT_MS,
  APPLE_PAY_SUCCESS_STATUSES,
  CURRENCY_CODE,
  ApplePayButtonStatus,
  PaymentStatusApplePay,
};
